import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { axiosNewInstance } from "../../config/Api";
import { connect } from "react-redux";
import LangData from "../common/LangData";
// import Select from "react-select";

// const options = [
//   { value: "56984", label: "56984" },
//   { value: "56964", label: "56964" },
//   { value: "56684", label: "56684" },
//   { value: "55654", label: "55654" },
//   { value: "36984", label: "36984" },
//   { value: "45698", label: "45698" },
//   { value: "69875", label: "69875" },
// ];

const DashboardHome = ({ lang, setActiveItem }) => {
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState([]);
  const history = useHistory();
  const token = localStorage.getItem("authToken");
  useEffect(() => {
    if (token) {
      fetchDashboardData();
    } else {
      history.push("/login");
    }
  }, []);

  const fetchDashboardData = async (page = 1) => {
    const FETCH_DASHBOARD_URL = "/api-app/customer-dashboard";
    setLoading(true);
    try {
      const response = await axiosNewInstance.post(
        FETCH_DASHBOARD_URL,
        { page },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Fetched user dashboard data:", response.data.data.policies);
      setDashboardData(response?.data?.data?.policies || []);
    } catch (error) {
      console.error("Error fetching user dashboard:", error?.response || error);
      // if (error.response?.data?.status === 0) {
      //   localStorage.removeItem("authToken");
      //   history.push("/login");
      // }
    } finally {
      setLoading(false);
    }
  };

  // const handleChange = () => {};

  // const customStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: 300,
  //   }),
  // };
  const handleViewAll = () => {
    setActiveItem("Policy List");
    // localStorage.setItem("activeItem", "Policy List");
  };
  const handleView = (policyId) => {
    history.push(`/policy-view-customer/${policyId}`);
  };

  return (
    <div className="container dashboard_home_container">
      {/* <div className="d-flex flex-column flex-md-row my-5 mx-3">
        <p className="mb-3 mb-md-0 text-nowrap fs-4 mt-1 font-weight-bold">
          Pay Premium:
        </p>
        <div className="d-flex align-items-center">
          <form className="d-flex w-100">
            <Select
              options={options}
              onChange={handleChange}
              placeholder="Policy No..."
              className="mx-0 mx-md-3 flex-grow-1"
              styles={customStyles}
            />
            <button type="submit" className="btn btn-primary py-1 mx-2">
              Pay Now
            </button>
          </form>
        </div>
      </div> */}

      <div className="">
        <div className="row g-0">
          <div className="col-md-12 pr-2">
            <div className="card p-3 shadow-sm">
              <div className="d-flex justify-content-between align-items-center">
              <h5 className="font-weight-bold fs-4 my-3">
              <LangData keyname="label_policy_list" />
              </h5>
                {dashboardData?.length >= 6 && (
                  <button
                    className="btn btn-primary my-2"
                    onClick={handleViewAll}
                    style={{ backgroundColor: "#004E8F", padding: "8px 25px" }}
                  >
                    View All
                  </button>
                )}
              </div>
              <div className="table-responsive">
                <table className="table text-left">
                  <thead>
                    <tr>
                    <th scope="col"><LangData keyname="label_serial" /></th>
                    <th scope="col"><LangData keyname="label_name" /></th>
                       <th scope="col"><LangData keyname="label_policy_id" /></th>
                       <th scope="col"><LangData keyname="label_ref_id" /></th>
                       <th scope="col"><LangData keyname="label_mobile" /></th>
                       <th scope="col"><LangData keyname="label_product_name" /></th>
                       <th scope="col"><LangData keyname="label_action" /></th>
                      {/* <th scope="col">Status</th> */}
                    </tr>
                  </thead>
                  <tbody>
                  {dashboardData && dashboardData.length > 0 ? (
                      dashboardData.map((item, index) => (
                      <tr key={item?.id}>
                        <td>{index + 1}</td>
                        <td>{`${item?.customer?.first_name || ""} ${item?.customer?.last_name || ""}`}</td>
                        <td>{item?.sap_policy_id}</td>
                        <td>{item?.ref_unique_id}</td>
                        <td>{item?.customer?.mobile || "N/A"}</td>
                        <td>{item?.policy?.name || "N/A"}</td>
                        {/* <td
                          className={
                            item?.status === 2 
                              ? "text-primary"
                              : item?.status === 3 
                              ? "text-success"
                              : item?.status === 1 
                              ? "text-warning"
                              : "text-danger" 
                          }
                        >
                          {
                            item?.status === 0 ? "Draft" :
                            item?.status === 1 ? "Submitted" :
                            item?.status === 2 ? "Active" :
                            item?.status === 3 ? "Closed" :
                            "Unknown" 
                          }
                        </td> */}
                          <td style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <button
                              className="btn btn-primary btn-sm ms-1"
                              onClick={() => handleView(item?.id)}
                            >
                              <i className="fas fa-eye"></i>
                            </button>

                          </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center text-muted">
                        No Data Available
                      </td>
                    </tr>
                  )}

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  lang: state.lang,
});

export default connect(mapStateToProps)(DashboardHome);
